import React, { useLayoutEffect, useRef, useState } from 'react';
import { Tabs } from 'antd';

export default function AnimatedTabs({ onChange, ...props }) {
  const root = useRef(null);
  const [selection, setSelection] = useState(props.defaultActiveKey);
  useLayoutEffect(() => {
    const element = root.current;
    const measure = () => {
      const list = element?.querySelector('.ant-tabs-nav-list');
      const active = list?.querySelector('.ant-tabs-tab-active');
      if (!active) return;
      const base = list.getBoundingClientRect();
      list.style.setProperty('--nc-left', `${active.getBoundingClientRect().left - base.left}px`);
      list.style.setProperty('--nc-width', `${active.offsetWidth}px`);
      list.querySelectorAll('.ant-tabs-tab-btn').forEach(label => {
        label.style.setProperty('--label-left', `${label.getBoundingClientRect().left - base.left}px`);
      });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [props.activeKey, props.items, props.children, selection]);
  return <div ref={root} className="animated-tabs"><Tabs {...props} onChange={key => { setSelection(key); onChange?.(key); }} /></div>;
}
AnimatedTabs.TabPane = Tabs.TabPane;
